export default "<div class=\"page-title\">\n    <h1>Home</h1>\n</div>\n\n<p>Navigate to a dashboard using the navbar.</p>\n";